"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ArrowLongUp;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ArrowLongUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Arrows_",
    "data-name": "Arrows+"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "arrow-long-up"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-2",
    "data-name": "outline",
    d: "M17.66,42.06a2.49,2.49,0,0,0,3.53,0L47.5,15.76V90a2.5,2.5,0,0,0,5,0V15.76L78.81,42.07a2.5,2.5,0,0,0,3.53-3.54L52.24,8.43a3.16,3.16,0,0,0-4.48,0l-30.1,30.1A2.49,2.49,0,0,0,17.66,42.06Z"
  }))));
}